// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import CollapsableBox from "./partials/collapsable-box";
import StickyFooterMenu from "./partials/sticky-footer-menu";
import EventCategoryMenu from "./partials/event-category-menu";
import Header from "./partials/header";
import Hero from "./partials/hero";
import EventSlider from "./partials/event-slider";
import EventInfo from "./partials/event-info";
import SearchList from "./partials/search-list";
import SharePageModal from "./partials/share-page-modal";
import Search from "./partials/search";
import EventTicketsTabs from "./partials/event-tickets-tabs";
import EventTicketsCalendar from "./partials/event-tickets-calendar";
import TicketkeeperForm from "./partials/ticketkeeper-form";
import EventImpression from "./partials/event-impression";
import DatePicker from "./partials/datepicker";
import TimePicker from "./partials/timepicker";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-collapsable-box]').forEach($el => new CollapsableBox($el));
    $wrapper.querySelectorAll('[data-event-category-menu]').forEach($el => new EventCategoryMenu($el));
    $wrapper.querySelectorAll('[data-event-info]').forEach($el => new EventInfo($el));
    $wrapper.querySelectorAll('[data-header]').forEach($el => new Header($el));
    $wrapper.querySelectorAll('[data-hero]').forEach($el => new Hero($el));
    $wrapper.querySelectorAll('[data-event-slider]').forEach($el => new EventSlider($el));
    $wrapper.querySelectorAll('[data-event-tickets-tabs]').forEach($el => new EventTicketsTabs($el));
    $wrapper.querySelectorAll('[data-event-tickets-calendar]').forEach($el => new EventTicketsCalendar($el));
    $wrapper.querySelectorAll('[data-share-page-modal]').forEach($el => new SharePageModal($el));
    $wrapper.querySelectorAll('[data-search]').forEach($el => new Search($el));
    $wrapper.querySelectorAll('[data-sticky-footer-menu]').forEach($el => new StickyFooterMenu($el));
    $wrapper.querySelectorAll('[data-search-list]').forEach($el => new SearchList($el));
    $wrapper.querySelectorAll('[data-ticketkeeper-form]').forEach($el => new TicketkeeperForm($el));
    $wrapper.querySelectorAll('[data-event-impression-url]').forEach($el => new EventImpression($el));
    $wrapper.querySelectorAll('[data-date-picker]').forEach($el => new DatePicker($el));
    $wrapper.querySelectorAll('[data-time-picker]').forEach($el => new TimePicker($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();
